import Vue from 'vue'
import Vuex from 'vuex'
import {
  login as loginApi,
  logout as logoutApi,
  getAdminInfo as getAdminInfoApi
} from '@/api/auth'
import {
  readPersistedSession,
  persistSession,
  clearPersistedSession,
  clearUserProfile,
  persistUserProfile
} from '@/utils/authStorage'

Vue.use(Vuex)

const persisted = readPersistedSession()

export default new Vuex.Store({
  state: {
    token: persisted.token,
    tokenExpires: persisted.tokenExpires,
    menus: persisted.menus,
    auths: persisted.auths,
    user: persisted.user
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    displayName: (state) => {
      const u = state.user
      if (!u) return '管理员'
      return (
        (u.realName && String(u.realName).trim()) ||
        (u.name && String(u.name).trim()) ||
        (u.username && String(u.username).trim()) ||
        '管理员'
      )
    },
    flatMenus: (state) =>
      (state.menus || []).filter(
        (m) => m && (m.status === 1 || m.status === '1')
      ),
    /** 校验是否拥有与后端 auth 字段对应的权限 */
    hasAuth:
      (state) =>
      (authKey) =>
        !authKey || (state.auths || []).includes(authKey)
  },
  mutations: {
    CLEAR_SESSION(state) {
      state.token = ''
      state.tokenExpires = 0
      state.menus = []
      state.auths = []
      state.user = null
      clearPersistedSession()
    },
    SET_SESSION(state, payload) {
      const { token, tokenExpires, menus, auths, username } = payload
      state.token = token || ''
      state.tokenExpires = tokenExpires || 0
      state.menus = menus || []
      state.auths = auths || []
      clearUserProfile()
      state.user = username
        ? { name: username, username, realName: '' }
        : null
      persistSession({
        token: state.token,
        tokenExpires: state.tokenExpires,
        menus: state.menus,
        auths: state.auths,
        username
      })
    },
    SET_ADMIN_INFO(state, { realName, username }) {
      const base = state.user || {}
      const u = username || base.username || ''
      const r = realName || ''
      state.user = {
        ...base,
        username: u,
        realName: r,
        name: r || u || base.name || '管理员'
      }
      persistUserProfile({ username: u, realName: r })
    }
  },
  actions: {
    login({ commit }, { username, password }) {
      if (!username || !password) {
        return Promise.reject(new Error('请输入账号和密码'))
      }
      return loginApi({ username, password }).then((data) => {
        const tokenObj = data.token || {}
        commit('SET_SESSION', {
          token: tokenObj.token || '',
          tokenExpires: tokenObj.expires_time || 0,
          menus: data.menus || [],
          auths: data.auths || [],
          username
        })
      })
    },
    logout({ commit }) {
      return logoutApi()
        .catch(() => {})
        .then(() => {
          commit('CLEAR_SESSION')
        })
    },
    fetchAdminInfo({ commit }) {
      return getAdminInfoApi().then((data) => {
        commit('SET_ADMIN_INFO', {
          realName: data?.realName,
          username: data?.username
        })
      })
    }
  }
})
